/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import withToggle from '../../../common/hoc/withToggle';
import GrossSalesBreakdownModal from './GrossSalesBreakdownModal';
import { MoneyFitLarge, MoneyFitMedium } from './MoneyFit';

const GrossSalesBreakdown = (props) => {
  const {
    shouldShowModalOn,
    shouldShowModalOff,
    shouldShowModalIsOn,
    grossSales,
    grossTotal,
    newMembershipGrossTotal,
    recurringMembershipGrossTotal,
    productGrossTotal,
    serviceGrossTotal,
    isMembershipDataVisible,
    isLargeSize,
  } = props;
  const MoneyValueComponent = isLargeSize ? MoneyFitLarge : MoneyFitMedium;

  return (
    <div className="u-type--underline u-cursor-pointer" onClick={shouldShowModalOn}>
      <MoneyValueComponent automationId="text:grossSalesAmount">{grossSales}</MoneyValueComponent>
      <GrossSalesBreakdownModal
        grossTotal={grossTotal}
        newMembershipGrossTotal={newMembershipGrossTotal}
        recurringMembershipGrossTotal={recurringMembershipGrossTotal}
        productGrossTotal={productGrossTotal}
        serviceGrossTotal={serviceGrossTotal}
        isMembershipDataVisible={isMembershipDataVisible}
        close={shouldShowModalOff}
        display-if={shouldShowModalIsOn}
      />
    </div>
  );
};

GrossSalesBreakdown.propTypes = {
  isLargeSize: PropTypes.bool.isRequired,
  grossSales: PropTypes.number.isRequired,
  grossTotal: PropTypes.number.isRequired,
  newMembershipGrossTotal: PropTypes.number.isRequired,
  recurringMembershipGrossTotal: PropTypes.number.isRequired,
  productGrossTotal: PropTypes.number.isRequired,
  serviceGrossTotal: PropTypes.number.isRequired,
  isMembershipDataVisible: PropTypes.bool.isRequired,
  shouldShowModalOn: PropTypes.func.isRequired,
  shouldShowModalOff: PropTypes.func.isRequired,
  shouldShowModalIsOn: PropTypes.bool.isRequired,
};

export default withToggle('shouldShowModal', false)(GrossSalesBreakdown);
